<template>
  <div>
    <v-autocomplete
      :disabled="disabled || field.isReadOnly"
      v-bind:label="labelText"
      v-model="field.value"
      :items="filteredListElements"
      item-text="text"
      item-value="text"
      :loading="isLoading"
      :search-input.sync="search"
      :hint="field.observations"
      :error-messages="fieldErrors"
      :clearable="!field.isReadOnly"
      :multiple="field.multiValue"
      :chips="field.multiValue"
      :deletable-chips="field.multiValue"
      :small-chips="field.multiValue"
      @change="onChange"
      @input="validator.document.fields.$each[index].value.$touch();"
    >
      <template slot="append-outer">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              color="success"
              icon
              v-show="showAddData"
              @click="addInteralTableData"
            >
              <v-icon>mdi-table-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("InsertData") }}</span>
        </v-tooltip>
      </template>
    </v-autocomplete>
    <AddDataModal :ref="modalKey" @on-item-saved="onInternalDataSaved" />
  </div>
</template>
<script>
import ContentTypeService from "@/services/ContentTypeService";
import FieldType from "@/ecm/variables/FieldType";
import { EventBus } from "@/eventBus.js";
import AddDataModal from "@/components/document/documentModal/internalTable/AddDataModal";

export default {
  components: {
    AddDataModal,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
    ctIndex: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canAddData: {
      type: Boolean,
      default: false,
    },
    fieldChangeSource: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.getListElements();
    EventBus.$on("refreshListElements" + this.field.code, (parameters) => {
      this.getListElements(parameters, true);
    });
  },
  destroyed() {
    EventBus.$off("refreshListElements" + this.field.code);
  },
  data() {
    return {
      search: null,
      listElements: [],
      filteredListElements: [],
      isLoading: false,
      modalKey: "modalAddData",
    };
  },
  methods: {
    onInternalDataSaved() {
      this.getListElements();
      this.modalAddData.hide();
    },
    addInteralTableData() {
      if (this.showAddData) {
        this.modalAddData.showModal(
          this.field.defFieldId,
          this.field.internalTableId
        );
      }
    },
    getListElements(parameters) {
      if (this.field.type == FieldType.StaticList) {
        this.listElements = this.field.listElements || [];
        if (
          this.listElements.length > 0 &&
          this.validator.document &&
          this.validator.document.$model.id == 0 &&
          !this.field.value
        ) {
          this.field.value = this.listElements[0].text;
        }
        this.filterListElements();
      } else if (
        this.field.type == FieldType.DynamicList ||
        this.field.type == FieldType.DynamicTableList
      ) {
        if (this.field.fieldsOnWhichDepends.length > 0 && !parameters) {
          return;
        }
        this.isLoading = true;
        ContentTypeService.getListElementsByDefField(
          this.field.defFieldId,
          parameters
        )
          .then((result) => {
            if (result.length == 1)
              this.field.value = this.field.multiValue
                ? [result[0].text]
                : result[0].text;
            this.listElements = result;
            if (result.length == 0) this.field.value = null;
            this.filterListElements();
          })
          .finally((x) => (this.isLoading = false));
      }
    },
    filterListElements(search) {
      this.filteredListElements = (
        search
          ? this.listElements.filter((e) =>
              (e.text || "").toLowerCase().includes(search.toLowerCase())
            )
          : this.listElements
      ).slice(0, 200);

      if (this.field.value) {
        var fieldValues = this.field.multiValue
          ? this.field.value
          : [this.field.value];
        for (var fieldValue of fieldValues) {
          if (!this.filteredListElements.some((e) => e.text == fieldValue)) {
            var currElement = this.listElements.find(
              (e) => e.text == fieldValue
            );
            if (currElement) {
              this.filteredListElements.push(currElement);
            }
          }
        }
      }
    },
    onChange() {
      EventBus.$emit('field-edited', this.field, this.fieldChangeSource);
    },
  },
  computed: {
    fieldErrors() {
      const errors = [];
      if (this.validator.document) {
        if (!this.validator.document.fields.$each[this.index].value.$dirty)
          return errors;

        !this.validator.document.fields.$each[this.index].value.required &&
          errors.push(this.$t("RequiredField"));
      } else if (this.validator.contentTypeList) {
        if (
          !this.validator.contentTypeList.$each[this.ctIndex].document.fields
            .$each[this.index].value.$dirty
        )
          return errors;

        !this.validator.contentTypeList.$each[this.ctIndex].document.fields
          .$each[this.index].value.required &&
          errors.push(this.$t("RequiredField"));
      }

      return errors;
    },
    showAddData() {
      return (
        this.field.type == FieldType.DynamicTableList &&
        this.canAddData &&
        this.field.internalTableId > 0
      );
    },
    modalAddData() {
      return this.$refs[this.modalKey];
    },
    labelText() {
      return `${this.field.title}${this.field.isRequired ? " *" : ""}`;
    },
  },
  watch: {
    search(val) {
      val !== this.field.value && this.filterListElements(val);
    },
  },
};
</script>
<style>
.v-input__append-outer {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
